import { Box, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import { PASSWORD_RULES } from './passwordRules'
import { styles } from './P2PCreateAccount.styles'

export const PasswordRequirements = ({ password }: { password: string }): JSX.Element => (
  <Box component='ul' sx={styles.requirements} aria-label='Password requirements'>
    {PASSWORD_RULES.map(rule => {
      const met = rule.isMet(password)
      return (
        <Box component='li' key={rule.key} sx={styles.requirement(met)} data-testid={`passwordRule-${rule.key}`} data-met={met}>
          {met ? <CheckCircleIcon fontSize='small' /> : <RadioButtonUncheckedIcon fontSize='small' />}
          <Typography variant='body1' component='span'>{rule.label}</Typography>
        </Box>
      )
    })}
  </Box>
)
